module.exports = __webpack_public_path__ + "media/images/web_suite/resources_thumbs/featured-tour-thumbnail-423e25ccb32c1ac8df6b678434eb0980.png";